<template>
  <div>
    <nav-bar class="_not-dashboard" />
    <b-container
      fluid
      class="home"
      v-if="dashboardsLoaded"
      >
      <div>
        <div
          v-for="(dashboard, key) in dashboards"
          v-if="dashboard"
          :key="key"
          class="dashboardItem"
          >
          <a
            v-if="$can('update', 'Dashboard_' + key)"
            href="#"
            class="dashboardItem__edit"
            @click.prevent="editDashboard(key)"
            >
            <icon name="pencil" />
          </a>
          <a
            v-if="!$can('canNotDelete', 'Dashboard_' + key)"
            href="#"
            class="dashboardItem__remove"
            @click.prevent="removeDashboard(key)"
            >
            <icon name="remove" />
          </a>
          <router-link
            :to="'/dashboard/' + key"
            class="dashboardItem__trigger"
            >
            <span class="dashboardItem__content">
              &nbsp;
              <span
                :id="key"
                :contenteditable="dashboardToEdit === key && renameStarted"
                @blur="saveDashboardName"
                @keydown.enter.stop="blurInput"
                >{{ dashboard.name }}</span>
            </span>
          </router-link>
        </div>
        <div class="dashboardItem">
          <transition name="fade">
            <div
              v-if="inputVisible"
              class="dashboardItem__inputWrapper"
              ref="inputWrapper"
              >
              <b-input
                placeholder="Name of dashboard"
                @keydown.native.enter.prevent="saveDashboard"
                @blur.native="inputVisible = false"
                class="dashboardItem__input"
                ref="input"
                v-model="dashboardName"
                />
            </div>
          </transition>
          <a
            href="#"
            class="dashboardItem__trigger"
            @click.prevent="createDashboard"
            >
            <span class="dashboardItem__content dashboardItem__add">
              Add&nbsp;<icon name="plus-square" />
            </span>
          </a>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
// modules
import { mapState } from 'vuex'
// components
import NavBar from '@/components/NavBar'
// services
import db from '@/services/db'

let $ = window.$

export default {
  components: {
    NavBar
  },
  data () {
    return {
      dashboards: {},
      publicDashboards: {},
      inputVisible: false,
      dashboardName: '',
      dashboardToEdit: '',
      renameStarted: false,
      dashboardsLoaded: false
    }
  },
  computed: {
    ...mapState([
      'userId'
    ])
  },
  methods: {
    createDashboard () {
      this.inputVisible = true
      setTimeout(() => {
        let input = this.$refs.input
        input.focus()
        this.$inputCursorToEnd($(input['$el']))
      })
    },
    saveDashboard () {
      if (!this.dashboardName) return
      this.$store.commit('addProcess', {
        process: 'addDashboard',
        message: 'Creating'
      })
      db.dashboards.create(this.dashboardName, () => {
        db.dashboards.read((dashboards) => {
          this.dashboards = dashboards
          this.$store.commit('deleteProcess', 'addDashboard')

          this.setAccessRules(dashboards)
        })
      })
      this.dashboardName = ''
      setTimeout(() => {
        this.inputVisible = false
      })
    },
    removeDashboard (key) {
      let confirm = window.confirm('Are you sure?')
      if (!confirm) return

      this.$store.commit('addProcess', {
        process: 'removeDashboard',
        message: 'Deleting'
      })
      db.dashboards.delete(key, () => {
        db.dashboards.read((dashboards) => {
          this.dashboards = dashboards
          this.$store.commit('deleteProcess', 'removeDashboard')

          this.setAccessRules(dashboards)
        })
      })
    },
    editDashboard (key) {
      this.dashboardToEdit = key
      this.renameStarted = true

      let el = $('#' + key)
      el.focus()
      setTimeout(() => {
        this.$cursorToEnd(el.get(0))
      })
    },
    blurInput () {
      $('#' + this.dashboardToEdit).blur()
    },
    saveDashboardName () {
      db.dashboards.edit(this.dashboardToEdit, $('#' + this.dashboardToEdit).text())
      this.dashboardToEdit = ''
      this.renameStarted = false
    },
    setAccessRules (dashboards) {
      for (let key in dashboards) {
        db.access.dashboard(this.userId, key, (actions) => {
          if (!actions) return
          let rule = this.$buildACLRule('Dashboard_' + key, actions)
          this.$store.commit('updateCaslRules', rule)
        })
      }
    }
  },
  created () {
    this.$store.commit('addProcess', {
      process: 'dashboardsLoading'
    })

    db.dashboards.read((dashboards, publicDashboards) => {
      this.dashboards = dashboards
      this.publicDashboards = publicDashboards
      this.dashboardsLoaded = true

      this.$store.commit('deleteProcess', 'dashboardsLoading')

      this.setAccessRules(dashboards)
    })
  },
  beforeDestroy () {
    this.dashboards = null
    this.publicDashboards = null
  }
}
</script>

<style lang="scss" scoped>
@import '~$scss/globals';

.home {
  position: relative;
  padding: {
    top: 15px;
    bottom: 15px;
  }
  height: calc(100vh - 60px);
  overflow: hidden;
  overflow-y: auto;
  > div {
    @include cf;
    margin: 0 -20px;
    @include breakpoint(max-width $screenMd) {
      margin: 0 -10px;
    }
  }
}
.dashboardItem {
  position: relative;
  @include span(3);
  margin-bottom: 15px;
  @include breakpoint(max-width $screenMd) {
    @include span(4);
  }
  @include breakpoint(max-width $screenSm) {
    @include span(6);
    margin-bottom: 10px;
  }
  @include breakpoint(max-width $screenXs) {
    @include span(12);
  }
  float: left;
  height: 25vh;
  padding: 0 20px;
  @include breakpoint(max-width $screenMd) {
    padding: 0 10px;
  }
  @include breakpoint(max-width $screenSm) {
    padding: 0 10px;
  }
  &__trigger {
    display: block;
    height: 100%;
    border: 1px solid $borderColor1;
    color: $color2;
    text-decoration: none;
    font: {
      size: 20px;
      family: $font2;
    }
  }
  &:hover,
  &:focus {
    .dashboardItem__content {
      color: $color2;
    }
  }
  &__content {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    text-align: center;
  }
  &__inputWrapper {
    position: relative;
    position: absolute;
    left: 20px;
    top: 0;
    width: calc(100% - 40px);
    height: 100%;
    @include breakpoint(max-width $screenMd) {
      left: 10px;
      width: calc(100% - 20px);
    }
  }
  &__input {
    position: absolute;
    left: 10px;
    top: calc(50% - 20px);
    width: calc(100% - 20px);
  }
  &__edit,
  &__remove {
    position: absolute;
    top: 5px;
    color: $color3;
    &:hover,
    &:focus {
      color: $color2;
    }
  }
  &__edit {
    right: 50px;
  }
  &__remove {
    right: 30px;
  }
}
.loading {
  padding: {
    left: 15px;
    top: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue